
/* ========================================
   LUMARA — Interactive Logic
   ======================================== */

// ===== Cart System =====

// ===== Shopify Real Cart =====
let shopifyCart = null;
let selectedProductId = (window.AURUNE_DEFAULT_PRODUCT || '6');

function formatMoney(cents) {
    return '$' + ((cents || 0) / 100).toFixed(2);
}
function formatPrice(cents) { return formatMoney(cents); }

function fetchCart(callback) {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(c) {
            shopifyCart = c;
            updateCartCount(c.item_count);
            renderCart(c);
            if (typeof callback === 'function') callback(c);
        })
        .catch(function() { updateCartCount(0); });
}

function updateCartCount(n) {
    var el = document.getElementById('cartCount');
    if (el) el.textContent = n || 0;
}

function renderCart(cart) {
    var cartBody = document.getElementById('cartBody');
    var cartFooter = document.getElementById('cartFooter');
    if (!cartBody) return;
    if (!cart || cart.item_count === 0) {
        cartBody.innerHTML = '<div class="cart-empty"><span class="cart-empty-icon">&#128722;</span><p>Your cart is empty</p><span>Begin your binding ritual</span></div>';
        if (cartFooter) cartFooter.style.display = 'none';
        return;
    }
    if (cartFooter) cartFooter.style.display = 'block';
    var html = '';
    cart.items.forEach(function(item, i) {
        var img = item.image
            ? '<img src="' + item.image + '" alt="">'
            : '<span class="cart-emoji">&#10022;</span>';
        var meta = '';
        if (item.properties) {
            Object.keys(item.properties).forEach(function(k) {
                var v = item.properties[k];
                if (v) meta += '<div class="cart-item-meta">' + k + ': ' + v + '</div>';
            });
        }
        html += '<div class="cart-item">' +
            '<div class="cart-item-img">' + img + '</div>' +
            '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + item.product_title + '</div>' +
            meta +
            '<div class="cart-item-price">' + formatMoney(item.final_line_price) +
            (item.quantity > 1 ? ' (' + item.quantity + 'x)' : '') + '</div>' +
            '</div>' +
            '<button class="cart-item-remove" onclick="removeCartItem(' + (i + 1) + ')">&#10005;</button>' +
            '</div>';
    });
    cartBody.innerHTML = html;
    var sub = document.getElementById('cartSubtotal');
    if (sub) sub.textContent = formatMoney(cart.total_price);
}

function removeCartItem(line) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function() { fetchCart(); });
}

function addToCart() {
    showToast('This add-on is not available yet', 'warn');
}

// ===== Add to Cart Button =====

// ===== Add to Cart Button (real Shopify cart) =====
document.getElementById('addToCartBtn').addEventListener('click', function() {
    var zodiacEl = document.getElementById('custZodiac');
    var zodiac = zodiacEl ? zodiacEl.value.trim() : '';
    var intentionEl = document.querySelector('input[name="intention"]:checked');
    var intention = intentionEl ? intentionEl.value : '';

    if (!zodiac) {
        showToast('Please enter your zodiac sign or birth date', 'warn');
        if (zodiacEl) zodiacEl.focus();
        return;
    }

    var product = window.AURUNE_PRODUCTS ? window.AURUNE_PRODUCTS[selectedProductId] : null;
    if (!product || !product.variantId) {
        showToast('This talisman is not available yet', 'warn');
        return;
    }

    var intentionLabels = { wealth: 'Wealth', love: 'Love', luck: 'Luck' };
    var btn = this;
    btn.disabled = true;
    var original = btn.innerHTML;
    btn.innerHTML = '<span>Binding your energy...</span>';

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: product.variantId,
                quantity: 1,
                properties: {
                    'Zodiac / Birth Date': zodiac,
                    'Intention': intentionLabels[intention] || intention,
                    'Talisman': product.title
                }
            }]
        })
    })
    .then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
    })
    .then(function() {
        if (zodiacEl) zodiacEl.value = '';
        showToast('Added to your sacred cart');
        fetchCart(function() { openCart(); });
    })
    .catch(function() {
        showToast('Could not add to cart. Please try again.', 'warn');
    })
    .then(function() {
        btn.disabled = false;
        btn.innerHTML = original;
    });
});

// ===== Upsell =====
function addUpsell(type) {
    if (type === 'sage') {
        addToCart({
            id: 'sage-bundle',
            name: 'Sage Cleansing Bundle',
            emoji: '🌿',
            price: 999,
            meta: { note: 'Energy cleansing for your talisman' }
        });
    } else if (type === 'bogo') {
        addToCart({
            id: 'bogo-soulmate',
            name: 'BOGO for Soulmate (2nd Necklace 50% Off)',
            emoji: '💕',
            price: 1499,
            meta: { note: 'Bound for two souls' }
        });
    }
}

// ===== Cart Drawer =====
function openCart() {
    document.getElementById('cartDrawer').classList.add('active');
    document.getElementById('cartOverlay').classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeCart() {
    document.getElementById('cartDrawer').classList.remove('active');
    document.getElementById('cartOverlay').classList.remove('active');
    document.body.style.overflow = '';
}

document.getElementById('cartBtn').addEventListener('click', function() { fetchCart(); openCart(); });
document.getElementById('cartClose').addEventListener('click', closeCart);
document.getElementById('cartOverlay').addEventListener('click', closeCart);

// ===== Toast =====
let toastTimer;
function showToast(message, type = 'success') {
    const toast = document.getElementById('toast');
    const icon = type === 'warn' ? '⚠' : '✦';
    toast.querySelector('.toast-icon').textContent = icon;
    toast.querySelector('.toast-text').textContent = message;
    toast.classList.add('active');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('active'), 3000);
}

// ===== Navbar Scroll Effect =====
const navbar = document.getElementById('navbar');
window.addEventListener('scroll', () => {
    if (window.scrollY > 60) {
        navbar.classList.add('scrolled');
    } else {
        navbar.classList.remove('scrolled');
    }
});

// ===== Mobile Nav Toggle =====
const navToggle = document.getElementById('navToggle');
const navLinks = document.getElementById('navLinks');
navToggle.addEventListener('click', () => {
    navToggle.classList.toggle('active');
    navLinks.classList.toggle('active');
});
navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
        navToggle.classList.remove('active');
        navLinks.classList.remove('active');
    });
});

// ===== Countdown Timer =====
function startCountdown() {
    // Set deadline to ~2 days from now
    const deadline = new Date();
    deadline.setDate(deadline.getDate() + 2);
    deadline.setHours(23, 59, 59);

    function update() {
        const now = new Date();
        const diff = deadline - now;

        if (diff <= 0) {
            // Reset to another 2 days
            deadline.setDate(deadline.getDate() + 2);
            return update();
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((diff % (1000 * 60)) / 1000);

        document.getElementById('cdDays').textContent = String(days).padStart(2, '0');
        document.getElementById('cdHours').textContent = String(hours).padStart(2, '0');
        document.getElementById('cdMins').textContent = String(mins).padStart(2, '0');
        document.getElementById('cdSecs').textContent = String(secs).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
}

// ===== Stock Randomizer (simulates live inventory) =====
function initStockCounter() {
    const stockEl = document.getElementById('stockCount');
    const scarcityEl = document.getElementById('scarcityStock');
    let stock = 7;

    // Occasionally decrease stock to simulate purchases
    setInterval(() => {
        if (stock > 3 && Math.random() > 0.7) {
            stock--;
            stockEl.textContent = stock;
            if (scarcityEl) scarcityEl.textContent = stock;
            const fillPercent = (stock / 50) * 100;
            document.getElementById('stockFill').style.width = fillPercent + '%';
            const scarcityFill = document.getElementById('scarcityFill');
            if (scarcityFill) scarcityFill.style.width = fillPercent + '%';
        }
    }, 15000);
}

// ===== Scroll Reveal =====
const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
        }
    });
}, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ===== Hero Ash Particle Generation (incense / candlelight) =====
function createHeroAsh() {
    const container = document.getElementById('heroAsh');
    if (!container) return;
    for (let i = 0; i < 40; i++) {
        const particle = document.createElement('div');
        particle.className = 'ash-particle';
        const size = Math.random() * 2 + 1;
        const startX = Math.random() * 100;
        const startY = 30 + Math.random() * 60;
        const delay = Math.random() * 8;
        const duration = Math.random() * 6 + 7;
        const drift = (Math.random() - 0.5) * 80;
        particle.style.cssText = `
            width: ${size}px;
            height: ${size}px;
            left: ${startX}%;
            top: ${startY}%;
            animation-delay: ${delay}s;
            animation-duration: ${duration}s;
            --drift: ${drift}px;
        `;
        container.appendChild(particle);
    }

    // Add per-particle drift animation
    const style = document.createElement('style');
    style.textContent = `
        @keyframes ashFloat {
            0% { transform: translateY(0) translateX(0); opacity: 0; }
            10% { opacity: 0.8; }
            90% { opacity: 0.4; }
            100% { transform: translateY(-180px) translateX(var(--drift, 30px)); opacity: 0; }
        }
    `;
    document.head.appendChild(style);
}

// ===== Smooth Scroll for Anchor Links =====
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            e.preventDefault();
            const offset = 80;
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    });
});

// ===== Init =====
document.addEventListener('DOMContentLoaded', function() {
    updateCartCount();
    renderCart();
    startCountdown();
    initStockCounter();
    createHeroAsh();
});


        let checkoutExtras = [];

        function renderSummary() {
            const cart = JSON.parse(localStorage.getItem('lumara_cart') || '[]');
            const allItems = [...cart, ...checkoutExtras];
            const container = document.getElementById('summaryItems');

            if (allItems.length === 0) {
                container.innerHTML = '<p style="text-align:center;color:var(--text-dim);padding:20px;">Your cart is empty</p>';
                document.getElementById('sumSubtotal').textContent = '$0.00';
                document.getElementById('sumTotal').textContent = '$0.00';
                document.getElementById('payBtnTotal').textContent = '$0.00';
                document.getElementById('sumTax').textContent = '$0.00';
                return;
            }

            let html = '';
            let subtotal = 0;
            allItems.forEach(item => {
                subtotal += item.price * (item.qty || 1);
                let metaText = '';
                if (item.meta) {
                    const parts = [];
                    if (item.meta.name) parts.push(item.meta.name);
                    if (item.meta.zodiac) parts.push(item.meta.zodiac);
                    if (item.meta.intention) parts.push(item.meta.intention);
                    if (item.meta.note) parts.push(item.meta.note);
                    metaText = parts.join(' · ');
                }
                html += `
                    <div class="summary-item">
                        <div class="summary-item-emoji">${item.emoji || '✦'}</div>
                        <div class="summary-item-info">
                            <div class="summary-item-name">${item.name}</div>
                            ${metaText ? `<div class="summary-item-meta">${metaText}</div>` : ''}
                        </div>
                        <div class="summary-item-price">${formatPrice(item.price * (item.qty || 1))}</div>
                    </div>
                `;
            });

            container.innerHTML = html;
            const tax = Math.round(subtotal * 0.08);
            const total = subtotal + tax;
            document.getElementById('sumSubtotal').textContent = formatPrice(subtotal);
            document.getElementById('sumTax').textContent = formatPrice(tax);
            document.getElementById('sumTotal').textContent = formatPrice(total);
            document.getElementById('payBtnTotal').textContent = formatPrice(total);
        }

        function toggleUpsell(type, price, checkbox) {
            if (checkbox.checked) {
                if (type === 'sage') {
                    checkoutExtras.push({ id: 'sage-bundle', name: 'Sage Cleansing Bundle', emoji: '🌿', price: price, meta: { note: 'Energy cleansing' } });
                } else {
                    checkoutExtras.push({ id: 'bogo-soulmate', name: 'BOGO for Soulmate', emoji: '💕', price: price, meta: { note: 'Bound for two' } });
                }
            } else {
                checkoutExtras = checkoutExtras.filter(item => 
                    !(type === 'sage' && item.id === 'sage-bundle') &&
                    !(type === 'bogo' && item.id === 'bogo-soulmate')
                );
            }
            renderSummary();
        }

        function expressPay(method) {
            showToast('Redirecting to ' + method + '...');
        }

        function placeOrder() {
            const email = document.getElementById('checkoutEmail').value.trim();
            if (!email) { showToast('Please enter your email', 'warn'); return; }
            const name = document.getElementById('checkoutName').value.trim();
            if (!name) { showToast('Please enter your name', 'warn'); return; }
            const address = document.getElementById('checkoutAddress').value.trim();
            if (!address) { showToast('Please enter your address', 'warn'); return; }

            showToast('Order placed! Your talisman is being bound... 🔮');
            setTimeout(() => {
                localStorage.removeItem('lumara_cart');
                checkoutExtras = [];
                renderSummary();
                updateCartCount();
                document.querySelector('.checkout-main').innerHTML = `
                    <div style="text-align:center;padding:80px 20px;">
                        <div style="font-size:4rem;margin-bottom:20px;">🔮✨</div>
                        <h1 style="font-size:2.4rem;margin-bottom:18px;color:var(--candle-gold);font-family:var(--font-serif);font-weight:400;letter-spacing:0.05em;">Your Binding Begins</h1>
                        <p style="color:var(--text-main);font-family:var(--font-serif);font-style:italic;font-size:1.1rem;margin-bottom:24px;max-width:440px;margin-left:auto;margin-right:auto;line-height:1.85;">
                            Your talisman is now entering the sacred charging ritual. You will receive a confirmation email with tracking and ritual instructions within 24 hours.
                        </p>
                        <div class="seal-stamp" style="margin:32px auto;display:inline-block;">Energy Bound</div>
                        <p style="color:var(--candle-gold);font-family:var(--font-serif);font-size:1.2rem;margin-bottom:36px;letter-spacing:0.1em;">✦ The energy is already in motion ✦</p>
                        <button class="btn btn-primary" onclick="closeCheckout()">Return to Home</button>
                    </div>
                `;
            }, 1500);
        }

        // Card number formatting
        document.getElementById('cardNumber')?.addEventListener('input', function(e) {
            let val = e.target.value.replace(/\s/g, '').replace(/[^0-9]/g, '');
            val = val.match(/.{1,4}/g)?.join(' ') || val;
            e.target.value = val;
        });

        // Expiry formatting
        document.getElementById('cardExpiry')?.addEventListener('input', function(e) {
            let val = e.target.value.replace(/\D/g, '');
            if (val.length >= 2) val = val.substring(0,2) + '/' + val.substring(2);
            e.target.value = val;
        });

        renderSummary();
    

// ===== Single-file additions =====
// Product card switcher (was missing in the original build)

function selectProduct(el, imgSrc) {
    var mainImg = document.getElementById('mainProductImg');
    if (mainImg) mainImg.src = imgSrc;
    var label = document.getElementById('frameLabel');
    if (label && el.dataset.label) label.textContent = el.dataset.label;
    document.querySelectorAll('.collection-card').forEach(function(c) { c.classList.remove('active'); });
    el.classList.add('active');
    var intention = el.dataset.intention;
    if (intention) {
        var radio = document.querySelector('input[name="intention"][value="' + intention + '"]');
        if (radio) radio.checked = true;
    }
    selectedProductId = el.dataset.id || (window.AURUNE_DEFAULT_PRODUCT || '6');
    updatePriceDisplay();
    var prod = document.getElementById('product');
    if (prod) prod.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function updatePriceDisplay() {
    var p = window.AURUNE_PRODUCTS ? window.AURUNE_PRODUCTS[selectedProductId] : null;
    if (!p) return;
    var now = document.getElementById('priceNow');
    var was = document.getElementById('priceWas');
    var save = document.getElementById('priceSave');
    var btnPrice = document.getElementById('btnPrice');
    if (now) now.textContent = formatMoney(p.price);
    if (btnPrice) btnPrice.textContent = formatMoney(p.price);
    if (was && p.compareAt && p.compareAt > p.price) {
        was.style.display = '';
        was.textContent = formatMoney(p.compareAt);
        if (save) {
            save.style.display = '';
            save.textContent = 'Save ' + Math.round((p.compareAt - p.price) / p.compareAt * 100) + '%';
        }
    } else {
        if (was) was.style.display = 'none';
        if (save) save.style.display = 'none';
    }
}

// Landing <-> checkout view switch (replaces the separate cart.html page)

function openCheckout() {
    if (!shopifyCart || shopifyCart.item_count === 0) {
        showToast('Your cart is empty', 'warn');
        return;
    }
    window.location.href = '/checkout';
}
function closeCheckout() {
    document.body.classList.remove('checkout-mode');
    window.scrollTo(0, 0);
}
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.body.classList.contains('checkout-mode')) closeCheckout();
});



// ===== Init: sync with Shopify cart =====
document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
    updatePriceDisplay();
});
